export function validateEnv() {
  const explicitSupabaseEnv = process.env.REACT_APP_SUPABASE_ENV;
  const useDevSupabase =
    process.env.NODE_ENV !== 'production' ||
    explicitSupabaseEnv === 'development';

  const activeUrl = useDevSupabase
    ? process.env.REACT_APP_DEV_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL
    : process.env.REACT_APP_PROD_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL;

  const activeKey = useDevSupabase
    ? process.env.REACT_APP_DEV_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY
    : process.env.REACT_APP_PROD_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY;

  const missing = [];
  if (!activeUrl) missing.push(useDevSupabase ? 'REACT_APP_DEV_SUPABASE_URL/REACT_APP_SUPABASE_URL' : 'REACT_APP_PROD_SUPABASE_URL/REACT_APP_SUPABASE_URL');
  if (!activeKey) missing.push(useDevSupabase ? 'REACT_APP_DEV_SUPABASE_ANON_KEY/REACT_APP_SUPABASE_ANON_KEY' : 'REACT_APP_PROD_SUPABASE_ANON_KEY/REACT_APP_SUPABASE_ANON_KEY');

  if (missing.length > 0) {
    const message = `Missing required Supabase configuration: ${missing.join(
      ', ',
    )}. Check your .env.development / .env.production or Vercel environment configuration.`;
    // eslint-disable-next-line no-console
    console.error(message);
    throw new Error(message);
  }

  // Soft safety check: warn if a development build is pointing at production.
  // Uses the prod-URL env var as the comparison reference instead of hardcoding
  // the value in source. Set REACT_APP_PROD_SUPABASE_URL in BOTH dev and prod
  // env files so this check has something to compare against everywhere.
  // (It's not a secret — Supabase URLs are public API endpoints.)
  const prodUrlReference = process.env.REACT_APP_PROD_SUPABASE_URL;

  if (useDevSupabase && prodUrlReference && activeUrl === prodUrlReference) {
    // eslint-disable-next-line no-console
    console.warn(
      'WARNING: Development build appears to be pointing at the production Supabase project. ' +
        'Create a separate dev Supabase project and update REACT_APP_DEV_SUPABASE_URL / REACT_APP_DEV_SUPABASE_ANON_KEY in .env.development.',
    );
  }

  // Soft safety check: production builds default to prod Supabase unless REACT_APP_SUPABASE_ENV is set.
  if (process.env.NODE_ENV === 'production' && !explicitSupabaseEnv) {
    // eslint-disable-next-line no-console
    console.warn(
      'REACT_APP_SUPABASE_ENV is not set. Production builds default to production Supabase config. ' +
        'Set REACT_APP_SUPABASE_ENV=development for preview/dev deployments that should use the dev Supabase project.',
    );
  }
}